import { createReducer } from '@reduxjs/toolkit';

import { Plan } from '../../records/Plan';
import { fetchPlansAction } from './actions';

export interface State {
  readonly elements: Plan[];
  readonly isLoading: boolean;
}

const initialState: State = {
  isLoading: true,
  elements: [],
};

export default createReducer(initialState, (builder) => {
  builder.addCase(fetchPlansAction.fulfilled, (draft, { payload }) => {
    draft.isLoading = false;
    draft.elements = payload.data.map((plan) => Plan.parsePlan(plan));
  }).addCase(fetchPlansAction.rejected, (draft) => {
    draft.isLoading = false;
    draft.elements = [];
  });
});
